import styled, { CSSProperties } from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';

export const customSubtitle: CSSProperties = {
  textAlign: "center",
  fontFamily: DEFAULT_FONT_FAMILY,
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "normal",
  margin: "10px 0px 25px 0px",
}

export const Root = styled.div`
  width: 100%;
  font-size: 26px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
`;

export const Title = styled.div`
  text-align: center;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin: 76px 0px 2px 0px;
`;

export const Subtitle = styled.h3`
  text-align: center;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin: 10px 0px 25px 0px;
`;

export const StarsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const EditIconContainer = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  &:hover {
    background-color: rgba(18, 36, 66, 0.05);
  }
`;

export const Reviews = styled.div`
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000;
  margin: 15px 0px 56px 0px;
`;
